import {
	LS_KEY_AFTER_LOGIN_PATH,
	LS_KEY_EMAIL_LINK_LOGIN_KEY,
} from "@/config/localStorageKeys";
import { auth } from "@/libs/firebase";
import { Box, CircularProgress } from "@mui/material";
import { Container } from "@mui/system";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { useRouter } from "next/router";
import { useSnackbar } from "notistack";
import { useEffect, useRef } from "react";

export function ProcessingSignWithEmail() {
	const router = useRouter();
	const requestExecutedRef = useRef<boolean>();
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		if (requestExecutedRef.current) return;

		const href = window.location.href;

		if (isSignInWithEmailLink(auth, href)) {
			window.history.replaceState(null, "", window.location.pathname);

			let email = window.localStorage.getItem(LS_KEY_EMAIL_LINK_LOGIN_KEY);

			if (!email)
				email = window.prompt(
					"メールを受け取ったメールアドレスを入力してください",
				);

			if (!email) {
				enqueueSnackbar("ログインに失敗しました。再度お試しください。", {
					variant: "error",
					anchorOrigin: {
						vertical: "top",
						horizontal: "center",
					},
					autoHideDuration: 1000,
				});
				router.push("/signin-with-email");
				return;
			}

			requestExecutedRef.current = true;

			signInWithEmailLink(auth, email, href)
				.then(() => {
					const afterLoginPath = window.localStorage.getItem(
						LS_KEY_AFTER_LOGIN_PATH,
					);
					router.push(afterLoginPath || "/home");

					window.localStorage.removeItem(LS_KEY_AFTER_LOGIN_PATH);
					window.localStorage.removeItem(LS_KEY_EMAIL_LINK_LOGIN_KEY);

					enqueueSnackbar("ログインしました。", {
						variant: "success",
						anchorOrigin: {
							vertical: "top",
							horizontal: "center",
						},
						autoHideDuration: 1000,
					});
				})
				.catch((e) => {
					router.push("/signin-with-email");
					enqueueSnackbar("ログインに失敗しました。再度お試しください。", {
						variant: "error",
						anchorOrigin: {
							vertical: "top",
							horizontal: "center",
						},
					});
				});
		} else {
			enqueueSnackbar("ログインに失敗しました。再度お試しください。", {
				variant: "error",
				anchorOrigin: {
					vertical: "top",
					horizontal: "center",
				},
			});
		}
	}, [enqueueSnackbar, router]);

	return (
		<Container component="main" maxWidth="xs" style={{ padding: 0 }}>
			<Box
				width={"100%"}
				display="flex"
				minHeight={300}
				justifyContent="center"
				alignItems="center"
			>
				<CircularProgress color="primary" />
			</Box>
		</Container>
	);
}
